module.exports = __webpack_public_path__ + "1cd254ac69a9c59da8bc1d41e1f1dfff.pdf";